<div class="lesson-tile-study" [ngClass]="rootClassName" (scroll)="popoverRef.hide()">
  <div class="lesson-tile-study-content-container">
    <div class="lesson-tile-study-content" id={{tile.id}} [ngClass]="{'actionable':isActionable}" (click)="onAction(defaultAction.name)">
      <div class="lesson-tile-study-graph" title="{{percentTitle}}">
        <div class="lesson-tile-study-container">
          <div class="lesson-tile-study-progressbar">
            <circle-progress
              class="svg lesson-tile-study-img"
              [space]="-outerStrokeWidth"
              [percent]="percent"
              [radius]="radius"
              [showTitle]="false"
              [showUnits]="false"
              [showSubtitle]="false"
              [outerStrokeWidth]="outerStrokeWidth"
              [outerStrokeColor]="outerStrokeColor"
              [outerStrokeLinecap]="outerStrokeLinecap"
              [innerStrokeWidth]="innerStrokeWidth"
              [innerStrokeColor]="innerStrokeColor"
              [responsive]="false"
              [clockwise]="true"
              [startFromZero]="true"
              [lazy]="false"
              [animation]="false"
              [showImage]="true"
              imageSrc="{{imageURL|async}}"
              [imageHeight]="imageHeight"
              [imageWidth]="imageWidth"
              [showBackground]="false"
              [showInnerStroke]="true"
              [showZeroOuterStroke]="false"
              [renderOnClick]="false"
              ngxVisibilityLazyLoad
            ></circle-progress>
            @if (isDevOnly) { <span matBadge="dev" matBadgeSize="small" matBadgePosition="above" matBadgeOverlap="true" matBadgeColor="accent" matBadgeDescription="in dev"></span> }
          </div>
        </div>
      </div>
      <div class="lesson-tile-study-coltitle" title="{{defaultAction.label}}">
        <div class="lesson-tile-study-row">
          <div class="lesson-tile-study-col">
            <span class="level-tile-label-text labelregularsmall">{{ isNew ? 'New' : '' }}</span>
          </div>
          <div class="lesson-tile-study-col">
            <span class="level-tile-label-text labelmediummedium">{{ title }}</span>
            @if (isAssigned) {&nbsp;<mat-icon>school</mat-icon>}
          </div>
          <div class="lesson-tile-study-col">
            <span class="lesson-tile-study-text-status labelregularsmall">{{status}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="lesson-tile-study-action-container">
      @if (isMenuable || isActionable) {
        <div class="lesson-tile-study-action">
          @if (isMenuable && isOptions) {
            <img
              #_study_popover="bs-popover"
              [popover]="_popTemplate"
              [adaptivePosition]="true"
              [outsideClick]="true"
              placement="bottom"
              container="body"
              containerClass="popover-custom"
              [src]="options.iconURL"
              [alt]="options.iconALT"
              class="lesson-tile-study-icon"
            />
          } @else {
            <circle-progress
              (click)="onAction(action.name)"
              class="lesson-tile-study-icon rounded"
              [space]="-outerStrokeWidth"
              [percent]="percent"
              [radius]="21"
              [showTitle]="false"
              [showUnits]="false"
              [showSubtitle]="false"
              [outerStrokeWidth]="outerStrokeWidth"
              [outerStrokeColor]="action.iconStrokeColor"
              [outerStrokeLinecap]="outerStrokeLinecap"
              [innerStrokeWidth]="innerStrokeWidth"
              [innerStrokeColor]="action.iconStrokeColor"
              [responsive]="false"
              [clockwise]="true"
              [startFromZero]="true"
              [lazy]="false"
              [animation]="false"
              [showImage]="true"
              [imageSrc]="action.iconURL"
              [imageHeight]="54"
              [imageWidth]="54"
              [showBackground]="false"
              [showInnerStroke]="true"
              [showZeroOuterStroke]="false"
              [renderOnClick]="false"
            ></circle-progress>
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template #_popTemplate>
  <span (mouseleave)="popoverRef.hide()">
    <pop-ui-action-menu
      [actionMenu]="actionMenu"
      [spinner]="spinner"
      (actionSelected)="onAction($event)">
    </pop-ui-action-menu>
  </span>
</ng-template>
